module.exports = __webpack_public_path__ + "img/download.ba81c031.svg";